import { register, getPrefix } from '../../../Utils'

const VideoStage = el => {
  const prefix = getPrefix(el)
  const videoContainer = el.querySelector('.' + prefix + 'video')
  const videoId = videoContainer.dataset.videoid
  const playButton = el.querySelector('.' + prefix + 'play-button')
  const loader = el.querySelector('.' + prefix + 'loader')
  let initialized = false
  let player

  const showElement = (el) => {
    el.classList.add(prefix + 'active')
  }

  const hideElement = (el) => {
    el.classList.remove(prefix + 'active')
  }

  const initializeVideo = () => {
    playButton.classList.remove(prefix + 'active')
    loader.classList.add(prefix + 'active')
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    window.onYouTubeIframeAPIReady = function () {
      player = new YT.Player(videoContainer, {
        width: '1920',
        height: '1080',
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          showinfo: 0,
          modestbranding: 1,
          loop: 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      })
    }
  }

  playButton.addEventListener('click', () => {
    if (initialized) {
      player.playVideo()
    } else {
      initializeVideo()
    }
  })

  const onPlayerReady = (event) => {
    initialized = true
    player.setPlaybackQuality('highres')
    hideElement(loader)
    el.classList.add(prefix + 'is--playing')
    player.playVideo()
  }

  const onPlayerStateChange = (event) => {
    if (initialized) {
      if (event.data === YT.PlayerState.PLAYING) {
        hideElement(playButton)
      } else if (event.data === YT.PlayerState.ENDED) {
        player.playVideo()
      } else {
        showElement(playButton)
      }
    }
  }
}

register('VideoStage', VideoStage)
